import { IDashboardStore } from './types';

const initStore: IDashboardStore = {
  counters: null,
};

export default initStore;
